import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AccountService } from '../../../../services/account.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonfilterService } from '../../../../services/commonfilter.service';
import { RemoveadwordDialogComponent } from './removeadword-dialog/removeadword-dialog.component';
import { TitleCasePipe } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { UploadDataConfirmComponent } from './upload-data-confirm/upload-data-confirm.component';
import { UploadAccountDataConfirmComponent } from './upload-account-data-confirm/upload-account-data-confirm.component';
import { UploadServiceConfirmComponent } from './upload-service-confirm/upload-service-confirm.component';
import { UploadSettingsComponent } from './upload-settings/upload-settings.component';
import { UpdateInfoComponent } from './update-info/update-info.component'
import { CustomTemplatesService } from './custom-templates/custom-templates.service';
import { projectConstants } from '../../../../shared/constants/project-constants';
@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.css'],
  providers: [TitleCasePipe]
})
export class AccountDetailsComponent implements OnInit {

  changeZoomidForm: UntypedFormGroup;
  licenseInfo: any = {};
  SupportLoginInfo: any = {};
  baseLocation: any = {};
  accountDetails: any = {};
  id: any;
  multipleLocations: any;
  accountAdwords: any = [];
  virtualresponse;
  accountVerificationDetails: any = [];
  accContactInfo: any = [];
  timeSpec: any;
  multiSpec: any;
  complainceLevel: any = {};
  dayCompLevel: any;
  monthCompLevel: any;
  outOfCompLevel: any;
  currentMonthUsage: any;
  currentDayUsage: any;
  licenseMetrics: any = [];
  currentDay_comp: any[];
  branchDetails: any = {};
  configData: any = {};
  accountTypes: any = [];
  dayCompliance: any = [];
  monthCompliance: any = [];
  outOfComplaince: any = [];
  socialMedia: any = [];
  ynwDomain: any;
  userName: string;
  api_success: string;
  discount_detail;
  api_error: any;
  lifeTimeUsage: any;
  callingMode: any;
  currentJDNDetails: any;
  ContactInfoDeatils: any;
  value: any;
  status: any;
  data;
  dataa;
  callvalue;
  virtual_data: any;
  callvalues;
  showicon;
  showzoom;
  showWhatsapp;
  modeWhatsapp;
  modeZoom;
  metrics: any;
  metrices: any;
  selectedRowIndex = -1;
  p
  contactFirstName;
  contactLastName;
  primaryEmail;
  secondaryEmail;
  primaryPhoneNumber;
  secondaryPhoneNumber;
  whatsappPhoneNumber;
  showprint: boolean;
  showToken;
  showPaymentToken;
  showPaymentAppt;
  showPaymentOrder;
  showPaymentDonation;
  showBillPayment;
  showOrder;
  showAppointment;
  showDonation;
  showBill;
  statType: string;
  accountId: any;
  tokenData;
  donationPaymentData;
  orderPaymentData;
  apptPaymentData;
  tokenPaymentData;
  orderData;
  donationBillPaymentData
  apptData;
  token_datetype;
  order_datetype;
  order_dateCategory;
  bookingon_checkin;
  token_dateCategory;
  bookingdate_checkin;
  bookingon_payment_checkin;
  bookingon_payment_lastseven_checkin;
  bookingon_payment_appt;
  bookingon_payment_lastseven_appt;
  bookingon_payment_order;
  bookingon_billPayment;
  bookingon_payment_lastseven_order;
  bookingon_lastseven_bookingon_billPayment;
  bookingon_payment_donation;
  bookingon_payment_lastseven_donation
  bookingon_lastseven_checkin;
  bookingfor_lastseven_checkin;
  bookingfor_nextseven_checkin;
  bookingon_nextseven_checkin;
  bookingfor_tomarrow_checkin;
  bookingon_tomarrow_checkin;
  bookingon_appt;
  bookingdate_appt;
  bookingon_lastseven_appt;
  bookingfor_lastseven_appt;
  bookingfor_nextseven_appt;
  bookingon_nextseven_appt;
  bookingfor_tomarrow_appt;
  bookingon_tomarrow_appt;
  donationData;
  bookingon_donation;
  bookingon_lastseven_donation;
  paymentData;
  bookingon_payment;
  bookingon_lastseven_payment;
  token_lastBookingDate;
  order_lastBookingDate;
  stat_type: any;
  bookingType: any;
  showstat = false;
  bookingon_order;
  bookingdate_order;
  bookingon_lastseven_order;
  bookingfor_lastseven_order;
  bookingon_tomarrow_order;
  bookingfor_tomarrow_order;
  bookingon_nextseven_order;
  bookingfor_nextseven_order;
  bookType;

  customAppEnabled = false;
  error: string;
  appRegistered: boolean;
  accountConfig: any;
  accountConfigUrl: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private formbuilder: UntypedFormBuilder,
    private location: Location,
    private routerobj: Router,
    private route: ActivatedRoute,
    private activaterouterobj: ActivatedRoute,
    private accountService: AccountService,
    private dialog: MatDialog,
    private activated_route: ActivatedRoute,
    private commonService: CommonfilterService,
    private router: Router,
    private titleCase: TitleCasePipe,
    private templateService: CustomTemplatesService
  ) {
    this.commonService.getConfigData()
      .subscribe(res => {
        this.configData = res;
        this.accountTypes = this.configData.accTypes;

      });
    this.userName = localStorage.getItem('supportName');
  }


  ngOnInit() {
    this.showstat = false;
    this.activated_route.queryParams.subscribe(
      params => {
        this.stat_type = params.statType;
        this.bookingType = params.bookingType;
        this.bookType = params.bookType;
        console.log(this.stat_type);
      });
    // this.status = 'ACTIVE';
    // this.value = 'https://zoom';
    this.commonService.getConfigData()
      .subscribe(config => {
        this.configData = config;
        // console.log('congifData' + JSON.stringify(this.configData));
        console.log('newUI');
        this.ynwDomain = this.configData.ynwDomain;
      });
    this.accountService.getLicenseMetricData()
      .subscribe(res => {
        this.licenseMetrics = res;
        console.log(this.licenseMetrics)
      });


    this.accountDetails = this.activatedRoute.parent.snapshot.data['accountDetails'];
    console.log(this.accountDetails.account.id)
    this.accountId = this.accountDetails.account.id;
    if (this.accountDetails.account.baseLocation) {
      this.baseLocation = this.accountDetails.account.baseLocation;
      this.timeSpec = this.baseLocation.bSchedule.timespec;
      console.log(this.timeSpec);
    }

    this.multipleLocations = this.accountDetails.multipleLocations;
    if (this.accountDetails.account.branch) {
      this.branchDetails = this.accountDetails.account.branch;
    }
    if (this.accountDetails.account.socialMedia) {
      this.socialMedia = this.accountDetails.account.socialMedia;

    }
    this.getsupportdata()
    if (this.stat_type === 'CHECKIN' && this.bookType === 'check') {
      this.showstat = true;
      this.getTokenData();
    }
    else if (this.stat_type === 'APPT' && this.bookType === 'appointment') {
      this.showstat = true;
      this.getAppointmentsData();
    }
    else if (this.stat_type === 'ORDER' && this.bookType === 'order') {
      this.showstat = true;
      this.getOrderData();
    }
    else if (this.stat_type === 'DONATION' && this.bookType === 'donation') {
      this.showstat = true;
      this.getDonationData();
    }
    else if (this.stat_type === 'PREPAYMENT') {
      this.showstat = true;
      this.getBillData();
    }
   
    if (this.bookingType === 'checkin' && this.stat_type === 'CHECKIN') {
      this.getPaymentTokenData();
    }
    else if (this.bookingType === 'appt' && this.stat_type === 'APPT') {
      this.getPaymentApptData();
    }
    else if (this.bookingType === 'order' && this.stat_type === 'ORDER') {
      this.getPaymentorderData();
    }
    else if (this.bookingType === 'donation' && this.stat_type === 'DONATION') {
      this.getPaymentdonationData();
    }
    else if (this.stat_type === 'BILL_PAYMENT') {
      this.getPaymentBillData();
    }
    this.getLicenseDetails(this.accountDetails.account.id);
    this.getAdwords(this.accountDetails.account.id);
    this.getCallingMode(this.accountDetails.account.id);
    this.ContactInfo(this.accountDetails.account.id)
    // this.getJdn(this.accountDetails.account.id)


    this.getCustomAppRegDetails();


    // this.accountService.getJDNDetails(this.accountDetails.account.id)
    //   .subscribe(res => {
    //     this.currentJDNDetails = res;
    //     alert(this.currentJDNDetails)
    //   });
    // this.accountService.getContactInfo(this.accountDetails.account.id)
    // .subscribe(res => {
    //   this.ContactInfoDeatils = res;
    //   console.log(this.ContactInfoDeatils)
    // });
    this.accountVerificationDetails = this.accountDetails.accountVerificationDetails;
    this.accContactInfo = this.accountDetails.accContactInfo;
    // console.log(this.accContactInfo);
    console.log('this.accountVerificationDetails........' + this.accountVerificationDetails);
    this.complainceLevel = this.accountDetails.complainceLevel;
    // console.log(this.complainceLevel);
    if (this.complainceLevel) {
      if (this.complainceLevel.dayCompLevel) {
        this.dayCompLevel = JSON.parse(this.complainceLevel.dayCompLevel);
        this.dayCompliance = this.dayCompLevel.compliance;
        // console.log(this.dayCompliance);
      }
      if (this.complainceLevel.monthCompLevel) {
        this.monthCompLevel = JSON.parse(this.complainceLevel.monthCompLevel);
        this.monthCompliance = this.monthCompLevel.compliance;
        // console.log(this.monthCompliance);
      }
      if (this.complainceLevel.outOfCompLevel) {
        this.outOfCompLevel = JSON.parse(this.complainceLevel.outOfCompLevel);
        this.outOfComplaince = this.outOfCompLevel.compliance;
      }
      if (this.complainceLevel.currentMonthUsage) {
        this.currentMonthUsage = JSON.parse(this.complainceLevel.currentMonthUsage);
      }
      if (this.complainceLevel.currentDayUsage) {
        this.currentDay_comp = [];
        this.currentDayUsage = JSON.parse(this.complainceLevel.currentDayUsage);
        Object.keys(this.currentDayUsage).forEach(key => {
          this.currentDay_comp.push({ 'metricId': parseInt(key.split('_')[1], 10), 'value': this.currentDayUsage[key] });
        });

      }
      if (this.complainceLevel.nonTransientMetricUsage) {
        this.lifeTimeUsage = JSON.parse(this.complainceLevel.nonTransientMetricUsage);
      }

    }



  }
  getCustomAppRegDetails() {
    const self = this;
    this.accountService.getPresignedUrlforPWA(this.accountDetails.account.id).subscribe(
      (urls) => {
        console.log(urls);
        this.accountConfigUrl = urls['accountConfigUrl'];
      }
    );
    const url = projectConstants.UIS3PATH + self.accountDetails.account.uniqueId + "/account_config.json?" + new Date();
    self.templateService.getJsonFromS3(url).then(
      (account)=> {
        self.accountConfig = account;
        if (account) {
          if (account['customAppEnabled']) {
            self.appRegistered = true;
          } else {
            self.appRegistered = false;
          }
        } else {
          self.appRegistered = false;
        }
      }
    )
  }
  uploadPWAFile(url, file) {
    const _this = this;
    return new Promise(function (resolve, reject) {
      _this.accountService.uploadPWAFiles(url, file).subscribe(
        (status)=>{
          resolve(true);
        }, (error)=> {
          resolve(false);
        }
      );
    });
  }
  extractS3Files(accountId) {
    const _this = this;
    return new Promise(function (resolve, reject) {
      _this.accountService.extractPWAFiles(accountId).subscribe(
        (status)=>{
          resolve(true);
        }, (error)=> {
          resolve(false);
        }
      );
    });
  }
  registerCustomApp () {
    const _this = this;
    this.accountConfig['customAppEnabled'] = true;
    this.accountConfig['homeUrl'] = 'customapp/' + this.accountDetails.account.accEncUid;
    this.accountConfig['providerId'] = this.accountDetails.account.id;
    this.accountConfig['customversion']= '1.0'
    let accountConfigFile = new File([JSON.stringify(this.accountConfig)], 'account_config', { type: 'application/json',  lastModified: Date.now()});
    this.uploadPWAFile(this.accountConfigUrl, accountConfigFile).then(
      (configStatus) => {
        _this.extractS3Files(_this.accountDetails.account.id).then(
          (extractStatus) => {
            console.log(extractStatus);
          }
        )
      });
  }
  disableCustomApp () {
    const _this = this;
    this.accountConfig['customAppEnabled'] = false;
    let accountConfigFile = new File([JSON.stringify(this.accountConfig)], 'account_config', { type: 'application/json',  lastModified: Date.now()});
    this.uploadPWAFile(this.accountConfigUrl, accountConfigFile).then(
      (configStatus) => {
        _this.extractS3Files(_this.accountDetails.account.id).then(
          (extractStatus) => {
            console.log(extractStatus);
          }
        )
      });
  }
  capitilizeFirstLetter(textVal) {
    return this.titleCase.transform(textVal);

  }
  getAccountType(type) {
    let accountType = '';
    this.accountTypes.forEach(account => {
      if (account.value === type) {
        accountType = account.name;
        return true;
      }
    });
    return accountType;
  }
  getsupportdata() {
    this.accountService.getdata()
      .subscribe(res => {
        this.SupportLoginInfo = res;
        // console.log(this.SupportLoginInfo.smallDisplayName)
      });
  }
  loginToProviderAccount(accountId) {

    let adminLoginPath: string;
    adminLoginPath = '/business/admin/login/';
    // console.log(this.ynwDomain);
    // if (this.ynwDomain === 'https://test.jaldee.com' || this.ynwDomain === 'http://localhost:8080') {
    //   adminLoginPath = '/jaldee/admin/login/';
    // }
    // else {
    //   adminLoginPath = '/business/admin/login/';
    // }

    const loginUrl = this.ynwDomain + adminLoginPath + accountId + '/' + this.userName + '?type=' + this.SupportLoginInfo.smallDisplayName;
    window.open(loginUrl);
    // console.log(loginUrl);
  }
  // updateBusinessProfile(accountId) {
  //   this.accountService.updateBusinessProfile(accountId)
  //     .subscribe(res => {
  //       this.api_success = 'Business Profile updated successfully';
  //       setTimeout(() => {
  //         this.api_success = '';
  //       }, 2000);
  //     },
  //       (error) => {
  //         this.api_error = error.error;
  //       }
  //     );
  // }
  // uploadDataToCloud(accountId) {
  //   this.accountService.uploadDataToCloud(accountId)
  //     .subscribe(response => {
  //       this.api_success = 'Uploaded to cloud successfully';
  //       setTimeout(() => {
  //         this.api_success = '';
  //       }, 2000);
  //     },
  //       (error) => {
  //         this.api_error = error.error;
  //       }
  //     );
  // }

  getMerticName(metric_id) {
    let metricName = '';
    this.licenseMetrics.forEach(metric => {
      if (metric.id === metric_id) {
        metricName = metric.displayName;
        return;
      }
    });
    return metricName;
  }
  getLicenseDetails(accountId) {
    this.accountService.getLicenseInfo(accountId)
      .subscribe(res => {
        this.licenseInfo = res;
      });
  }
  gotoBookingStat(){
    this.router.navigate(['../../../../accountStat'], { queryParams: { accountId: this.accountDetails.account.id }, relativeTo: this.activatedRoute });
  }
  gotoPaymentStat(){
    this.router.navigate(['../../../../paymentStat'], { queryParams: { accountId: this.accountDetails.account.id }, relativeTo: this.activatedRoute });
  }
  getScheduleString(timeSpecObj) {
    return this.commonService.getScheduleStringFromTimeSpec(timeSpecObj);
  }
  getAdwords(accountId) {
    this.accountService.getAdwords(accountId)
      .subscribe(res => {
        this.accountAdwords = res;
      });

  }
  getPaymentTokenData() {
    this.showPaymentToken = !this.showPaymentToken
    this.statType = 'CHECKIN';
    this.accountId = this.accountDetails.account.id;
    this.accountService.getpaymentStats(this.statType, this.accountId).subscribe(
      (data) => {
        this.tokenPaymentData = data;
        this.tokenPaymentData.checkin.forEach(token_details_sp => {
          this.tokenPaymentData.checkin = token_details_sp;
          this.token_datetype = this.tokenPaymentData.checkin.dateType;
          this.token_dateCategory = this.tokenPaymentData.checkin.dateCategory;
          this.token_lastBookingDate = this.tokenPaymentData.lastBookingDate;
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY') {
            this.bookingon_payment_checkin = this.tokenPaymentData.checkin.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingon_payment_lastseven_checkin = this.tokenPaymentData.checkin.stats;
          }

        });
      }
    )
  }
  getPaymentApptData() {
    this.showPaymentAppt = !this.showPaymentAppt
    this.statType = 'APPT';
    this.accountId = this.accountDetails.account.id;
    this.accountService.getpaymentStats(this.statType, this.accountId).subscribe(
      (data) => {
        this.apptPaymentData = data;
        this.apptPaymentData.appt.forEach(token_details_sp => {
          this.apptPaymentData.appt = token_details_sp;
          this.token_datetype = this.apptPaymentData.appt.dateType;
          this.token_dateCategory = this.apptPaymentData.appt.dateCategory;
          this.token_lastBookingDate = this.apptPaymentData.lastBookingDate;
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY') {
            this.bookingon_payment_appt = this.apptPaymentData.appt.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingon_payment_lastseven_appt = this.apptPaymentData.appt.stats;
          }

        });
      }
    )
  }
  getPaymentorderData() {
    this.showPaymentOrder = !this.showPaymentOrder
    this.statType = 'ORDER';
    this.accountId = this.accountDetails.account.id;
    this.accountService.getpaymentStats(this.statType, this.accountId).subscribe(
      (data) => {
        this.orderPaymentData = data;
        this.orderPaymentData.order.forEach(token_details_sp => {
          this.orderPaymentData.order = token_details_sp;
          this.token_datetype = this.orderPaymentData.order.dateType;
          this.token_dateCategory = this.orderPaymentData.order.dateCategory;
          this.token_lastBookingDate = this.orderPaymentData.lastBookingDate;
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY') {
            this.bookingon_payment_order = this.orderPaymentData.order.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingon_payment_lastseven_order = this.orderPaymentData.order.stats;
          }

        });
      }
    )
  }
  getPaymentBillData() {
    this.showBillPayment = !this.showBillPayment
    this.statType = 'BILL_PAYMENT';
    this.accountId = this.accountDetails.account.id;
    this.accountService.getpaymentStats(this.statType, this.accountId).subscribe(
      (data) => {
        // this.donationBillPaymentData = data;
        // this.donationBillPaymentData.billPayment.forEach(token_details_sp => {
        //   this.donationBillPaymentData.billPayment = token_details_sp;
        //   this.token_datetype = this.donationBillPaymentData.billPayment.dateType;
        //   this.token_dateCategory = this.donationBillPaymentData.billPayment.dateCategory;
        //   this.token_lastBookingDate = this.donationBillPaymentData.lastBookingDate;
        //   if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY') {
        //     this.bookingon_billPayment = this.donationBillPaymentData.billPayment.stats;
        //   }
        //   if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
        //     this.bookingon_lastseven_bookingon_billPayment = this.donationBillPaymentData.billPayment.stats;
        //   }

        // });
      }
    )
  }
  getPaymentdonationData() {
    this.showPaymentDonation = !this.showPaymentDonation
    this.statType = 'DONATION';
    this.accountId = this.accountDetails.account.id;
    this.accountService.getpaymentStats(this.statType, this.accountId).subscribe(
      (data) => {
        this.donationPaymentData = data;
        this.donationPaymentData.donation.forEach(token_details_sp => {
          this.donationPaymentData.donation = token_details_sp;
          this.token_datetype = this.donationPaymentData.donation.dateType;
          this.token_dateCategory = this.donationPaymentData.donation.dateCategory;
          this.token_lastBookingDate = this.donationPaymentData.lastBookingDate;
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY') {
            this.bookingon_payment_donation = this.donationPaymentData.donation.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingon_payment_lastseven_donation = this.donationPaymentData.donation.stats;
          }

        });
      }
    )
  }
  getTokenData() {
    this.showToken = !this.showToken
    this.statType = 'CHECKIN';
    this.accountId = this.accountDetails.account.id;
    this.accountService.getStats(this.statType, this.accountId).subscribe(
      (data) => {
        this.tokenData = data;
        this.tokenData.checkin.forEach(token_details_sp => {
          this.tokenData.checkin = token_details_sp;
          this.token_datetype = this.tokenData.checkin.dateType;
          this.token_dateCategory = this.tokenData.checkin.dateCategory;
          this.token_lastBookingDate = this.tokenData.lastBookingDate;
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY') {
            this.bookingon_checkin = this.tokenData.checkin.stats;
          }
          if (this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'TODAY') {
            this.bookingdate_checkin = this.tokenData.checkin.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingon_lastseven_checkin = this.tokenData.checkin.stats;
          }
          if (this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingfor_lastseven_checkin = this.tokenData.checkin.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TOMORROW') {
            this.bookingon_tomarrow_checkin = this.tokenData.checkin.stats;
          }
          if (this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'TOMORROW') {
            this.bookingfor_tomarrow_checkin = this.tokenData.checkin.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'NEXT_SEVEN_DAYS') {
            this.bookingon_nextseven_checkin = this.tokenData.checkin.stats;
          }
          if (this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'NEXT_SEVEN_DAYS') {
            this.bookingfor_nextseven_checkin = this.tokenData.checkin.stats;
          }
        });
      }
    )
  }
  getOrderData() {
    this.showOrder = !this.showOrder
    this.statType = 'ORDER';
    this.accountId = this.accountDetails.account.id;
    this.accountService.getStats(this.statType, this.accountId).subscribe(
      (data) => {
        this.orderData = data;
        this.orderData.order.forEach(token_details_sp => {
          this.orderData.order = token_details_sp;
          this.order_datetype = this.orderData.order.dateType;
          this.order_dateCategory = this.orderData.order.dateCategory;
          this.token_lastBookingDate = this.orderData.lastBookingDate;
          if (this.order_datetype === 'BOOKING_ON' && this.order_dateCategory === 'TODAY') {
            this.bookingon_order = this.orderData.order.stats;
          }
          if (this.order_datetype === 'BOOKING_SERVICE_DATE' && this.order_dateCategory === 'TODAY') {
            this.bookingdate_order = this.orderData.order.stats;
          }
          if (this.order_datetype === 'BOOKING_ON' && this.order_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingon_lastseven_order = this.orderData.order.stats;
          }
          if (this.order_datetype === 'BOOKING_SERVICE_DATE' && this.order_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingfor_lastseven_order = this.orderData.order.stats;
          }
          if (this.order_datetype === 'BOOKING_ON' && this.order_dateCategory === 'TOMORROW') {
            this.bookingon_tomarrow_order = this.orderData.order.stats;
          }
          if (this.order_datetype === 'BOOKING_SERVICE_DATE' && this.order_dateCategory === 'TOMORROW') {
            this.bookingfor_tomarrow_order = this.orderData.order.stats;
          }
          if (this.order_datetype === 'BOOKING_ON' && this.order_dateCategory === 'NEXT_SEVEN_DAYS') {
            this.bookingon_nextseven_order = this.orderData.order.stats;
          }
          if (this.order_datetype === 'BOOKING_SERVICE_DATE' && this.order_dateCategory === 'NEXT_SEVEN_DAYS') {
            this.bookingfor_nextseven_order = this.orderData.order.stats;
          }
        });
      }
    )
  }
  getAppointmentsData() {
    this.showAppointment = !this.showAppointment
    this.statType = 'APPT';
    this.accountId = this.accountDetails.account.id;
    this.accountService.getStats(this.statType, this.accountId).subscribe(
      (data) => {
        this.apptData = data;
        this.apptData.appt.forEach(appt_details_sp => {
          this.apptData.appt = appt_details_sp;
          this.token_datetype = this.apptData.appt.dateType;
          this.token_dateCategory = this.apptData.appt.dateCategory;
          this.token_lastBookingDate = this.apptData.lastBookingDate;
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY') {
            this.bookingon_appt = this.apptData.appt.stats;
          }
          if (this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'TODAY') {
            this.bookingdate_appt = this.apptData.appt.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingon_lastseven_appt = this.apptData.appt.stats;
          }
          if (this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingfor_lastseven_appt = this.apptData.appt.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TOMORROW') {
            this.bookingon_tomarrow_appt = this.apptData.appt.stats;
          }
          if (this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'TOMORROW') {
            this.bookingfor_tomarrow_appt = this.apptData.appt.stats;
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'NEXT_SEVEN_DAYS') {
            this.bookingon_nextseven_appt = this.apptData.appt.stats;
          }
          if (this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'NEXT_SEVEN_DAYS') {
            this.bookingfor_nextseven_appt = this.apptData.appt.stats;
          }
        });
      }
    )
  }
  getDonationData() {
    this.showDonation = !this.showDonation
    this.statType = 'DONATION';
    this.accountId = this.accountDetails.account.id;
    // console.log(this.accountId);
    this.accountService.getStats(this.statType, this.accountId).subscribe(
      (data) => {
        this.donationData = data;
        // console.log(this.donationData);
        this.donationData.donation.forEach(donation_details_sp => {
          this.donationData.donation = donation_details_sp;
          // console.log(this.donationData.donation);
          this.token_datetype = this.donationData.donation.dateType;
          this.token_dateCategory = this.donationData.donation.dateCategory;
          this.token_lastBookingDate = this.donationData.lastBookingDate;
          // console.log(this.token_datetype);
          // console.log(this.token_dateCategory);
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY') {
            this.bookingon_donation = this.donationData.donation.stats;
            // console.log(this.bookingon_donation);
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingon_lastseven_donation = this.donationData.donation.stats;
            // console.log(this.bookingon_lastseven_donation);
          }
        });
      }
    )
  }
  getBillData() {
    this.showBill = !this.showBill
    this.statType = 'PREPAYMENT';
    this.accountId = this.accountDetails.account.id;
    // console.log(this.accountId);
    this.accountService.getStats(this.statType, this.accountId).subscribe(
      (data) => {
        this.paymentData = data;
        // console.log(this.paymentData);
        this.paymentData.prepayment.forEach(payment_details_sp => {
          this.paymentData.prepayment = payment_details_sp;
          // console.log(this.paymentData.prepayment);
          this.token_datetype = this.paymentData.prepayment.dateType;
          this.token_dateCategory = this.paymentData.prepayment.dateCategory;
          this.token_lastBookingDate = this.paymentData.lastBookingDate;
          // console.log(this.token_datetype);
          // console.log(this.token_dateCategory);
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY') {
            this.bookingon_payment = this.paymentData.prepayment.stats;
            // console.log(this.bookingon_payment);
          }
          if (this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS') {
            this.bookingon_lastseven_payment = this.paymentData.prepayment.stats;
            // console.log(this.bookingon_lastseven_payment);
          }
        });
      }
    )
  }
  ContactInfo(accountId) {
    this.accountService.getContactInfo(accountId)
      .subscribe(res => {
        this.ContactInfoDeatils = res;
        // console.log(this.ContactInfoDeatils)
      });
  }
  getJdn(accountId) {
    this.accountService.getJDNDetails(accountId)
      .subscribe(res => {
        this.currentJDNDetails = res;
      })
  }
  getCallingMode(accountId) {
    this.accountService.getmodes(accountId)
      .subscribe(res => {
        this.virtualresponse = res;
        // console.log(this.virtualresponse)
        for (let i in this.virtualresponse) {
          this.callvalue = this.virtualresponse[i];
          for (let j in this.callvalue) {
            this.callvalues = this.callvalue[j];
            if (this.callvalues.callingMode === 'WhatsApp') {
              this.modeWhatsapp = this.callvalues.callingMode
              this.metrics = this.callvalue[j];
            } else {
              this.modeZoom = this.callvalues.callingMode
              this.metrices = this.callvalue[j];
            }
            if (this.callvalues.callingMode === 'WhatsApp') {
              this.showWhatsapp = true;
            }
            else if (this.callvalues.callingMode === 'Zoom') {
              this.showicon = true;
            }
            else {
              this.showWhatsapp = true;
              this.showicon = true;
            }
          }

        }

      });

  }
  onUpdateIdConfirm() {
    this.api_error = '';
    this.api_success = '';

    const data = [];
    if ((this.modeZoom === 'Zoom') && (this.modeWhatsapp === 'WhatsApp')) {
      data.push({ 'callingMode': 'Zoom', 'value': this.value, 'status': this.status });
      data.push({ 'callingMode': 'WhatsApp', 'value': this.metrics.value, 'status': this.metrics.status });
      const data1 = {
        'virtualCallingModes': data,

      };
      this.accountService.updateZoomid(this.accountDetails.account.id, data1)
        .subscribe(response => {
          this.api_success = 'Zoom ID Updated successfully';
          setTimeout(() => {
            this.api_success = '';
          }, 2000);
          this.getCallingMode(this.accountDetails.account.id);
          this.showzoom = false;
        },
          (error) => {
            this.api_error = error.error;
          });


    }
    else {
      data.push({ 'callingMode': 'Zoom', 'value': this.value, 'status': this.status });
      const data1 = {
        'virtualCallingModes': data,

      };
      this.accountService.updateZoomid(this.accountDetails.account.id, data1)
        .subscribe(response => {
          this.api_success = 'Zoom ID Updated successfully';
          setTimeout(() => {
            this.api_success = '';
          }, 2000);
          this.getCallingMode(this.accountDetails.account.id);
          this.showzoom = false;
        },
          (error) => {
            this.api_error = error.error;
          });
    }

  }
  updateZoomID() {
    this.showzoom = true;
    this.value = this.metrices.value;
    this.status = this.metrices.status;
  }

  goBacktoListt() {
    this.location.back();
  }
  // onUpdateIdConfirm() {
  //   this.api_error = '';
  //   this.api_success = '';
  //   // this.logValidationErrors();
  //   console.log(this.changeZoomidForm.get('callingMode').value);
  //   this.accountService.updateZoomid(this.accountDetails.account.id)
  //       .subscribe(res => {
  //         console.log(res);
  //       },
  //       );
  // }
  removeAdword(adword) {

    const dialogRef = this.dialog.open(RemoveadwordDialogComponent, {
      width: '600px',
      data: { 'accountId': this.accountDetails.account.id, 'adwordId': adword.id }

    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAdwords(this.accountDetails.account.id);

    });
    // this.accountService.deleteAdword(this.accountId,adwordId)
    // .subscribe(res=>{

    // })
  }
  uploadSettingsToCloud() {

    const dialogRef = this.dialog.open(UploadSettingsComponent, {
      width: '600px',
      data: this.accountDetails
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
    });
  }
  updateBusinessProfile() {
    const dialogRef = this.dialog.open(UploadDataConfirmComponent, {
      width: '600px',
      data: this.accountDetails
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
    });
  }
  updateInfo() {
    const dialogRef = this.dialog.open(UpdateInfoComponent, {
      width: '600px',
      data: this.ContactInfoDeatils
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
    });
    this.ContactInfo(this.accountDetails.account.id);
  }
  uploadDataToCloud() {
    const dialogRef = this.dialog.open(UploadAccountDataConfirmComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
    });
  }
  uploadServiceToCloud() {
    const dialogRef = this.dialog.open(UploadServiceConfirmComponent, {
      width: '600px',
      data: this.accountDetails
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
    });
  }
}
